<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:3pc"></p>
<p class="blockquotetext">What came of that mystical wedding, of the world we know and the world we do not know, by that rose of the spirit, committed thus in so great a hope, so great a faith? The Druid is not here to tell. Faith after Faith has withered like a leaf. But still we stand by ancestral altars, still offer the Rose of Desire to the veiled Mystery, still commit this our symbol to the fathomless, the everlasting, the unanswered Deep.</p>
<p class="right1">—W<span class="small">ILLIAM</span> S<span class="small">HARP</span>, from <i>Where the Forest Murmurs</i></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="center"><img alt="Image" src="images/pxxiv-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_epigraph.vue?4e7dfc03